// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PromoBadgeCTA_wrapper__LUEmK","text":"PromoBadgeCTA_text__B_oSx"};